// extracted by mini-css-extract-plugin
export default {"gameCard":"GameCard_gameCard__rD8jz","tiles":"GameCard_tiles__VTzRp","flowers":"GameCard_flowers__U9wVH","words":"GameCard_words__0MWpF","bubbles":"GameCard_bubbles__XOMQ0"};